export * from "./isConsumableMatrixItem";
